export default __webpack_public_path__ + "static/media/hacktoberfest.a1d0da17.png";